import React from 'react'
import {Pane,Dialog,Spinner, ChevronDownIcon, Text, HomeIcon, IconButton, toaster} from 'evergreen-ui'
import { gql,useQuery } from '@apollo/client';
import Cookies from 'js-cookie';
import {useHistory } from 'react-router-dom';

import {
    Tabbbo
} from  './dahsboard.style'
import AddEstatePopupWidget from './pages/estate/widgets/add_estate_popup_widget';
import { capitalizeFirstLetterOfWords } from '../../widget/util';


export const FETCH_ALL_ESTATE = gql`
query Facilities {
  facilities {
    _id
    code
    name
    facilityManager
    totalProperties
    occupiedProperties
    availableProperties
    address
    country
    state
    city
    createdAt
    id
  }
}
`;


function PickEstateBtn() {
const history = useHistory()
    const { loading, data }  = useQuery(FETCH_ALL_ESTATE);
    const [isShown, setIsShown] = React.useState(false)
    // const [selected, setSelected] = React.useState(null)
    const facilityName= Cookies.get('facilityName');
    return (
      <Pane>
        <Dialog
          isShown={isShown}
          title="Estate Management"
          onCloseComplete={() => setIsShown(false)}
          hasHeader={true}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEscapePress={false}
          hasFooter ={false}
        >
            
            <center className='mt-50'>
                {loading && <Spinner />}
            </center>
            <div className=' mb-50'>
                
                {data && <div>{
                      (data.facilities.length > 0) ?
                      data.facilities.map((estate)=>
                        <Tabbbo className="collection-item"
                            onClick={()=>{
                                setIsShown(false)
                                toaster.success(`${estate.name} selected.`)
                                Cookies.set('facilityId',`${estate._id}`)
                                Cookies.set('facilityCode',`${estate.code}`)
                                Cookies.set('facilityName',`${estate.name}`)
                                Cookies.set('facilityTotalProperties',`${estate.totalProperties}`)
                                Cookies.set('facilityOccupiedProperties',`${estate.occupiedProperties}`)
                                Cookies.set('facilityAvailableProperties',`${estate.availableProperties}`)

                                history.push("/dashboard")
                            }}
                            >
                            <i className='material-icons'style={{
                              marginTop:"10px"
                            }} >store_mall_directory</i>
                            <h6 className='pl-16'>{capitalizeFirstLetterOfWords(estate.name)}</h6>
                        </Tabbbo>
                    ):<AddEstatePopupWidget/>
                   }
                  </div>
                }
                
               
            </div>
        </Dialog>
        <div className='right'>
          <Text className='hide-on-small-only hide-on-med-only' color="muted">
            <b>Assets</b>
          </Text>    
          <button className='btn btn-flat transparent right hide-on-small-only hide-on-med-only'
            style={{
              border:"1px solid #eee",
              margin:"14px 16px 5px 10px",
              borderRadius:"5px",
              display:"flex"
            }}
            onClick={() => setIsShown(true)}>
                {facilityName}
              <div style={{
                width:"20px",
                height:"20px",
                marginTop:"2px",
                // border:"2px dashed red"
              }}>
                <ChevronDownIcon/>
              </div>
          </button>
          <IconButton 
              onClick={() => setIsShown(true)}
              style={{
                margin:"14px 16px 5px 10px",
              }}
              className='show-on-small show-on-medium hide-on-large-only' 
              icon={HomeIcon} 
            />
        </div>

      </Pane>
    )
}

export default PickEstateBtn




